import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "math-random"
    }}>{`Math random`}</h1>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://github.com/magento/magento2/blob/2.4/lib/internal/Magento/Framework/Math/Random.php"
      }}><inlineCode parentName="a">{`Magento\\Framework\\Math\\Random`}</inlineCode></a>{` library provides the ability to generate random values and hashes.`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Method`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`getRandomString`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Generates a random string with a given string length and an optional character pool. Without the optional character pool, it uses both cases of the English alphabet and all digits.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`getRandomNumber`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Generates a random number with an optional range. The range defaults to 0 as minimum and the result of the PHP function `}<inlineCode parentName="td">{`mt_getrandmax`}</inlineCode>{` as the maximum.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`getUniqueHash`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Generates a unique hash string with an optional prefix.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <p>{`In the examples below, the `}<inlineCode parentName="p">{`$this->mathRandom`}</inlineCode>{` property is an instantiated object of the `}<inlineCode parentName="p">{`Magento\\Framework\\Math\\Random`}</inlineCode>{` class.`}</p>
    <h3 {...{
      "id": "generate-a-random-string"
    }}>{`Generate a random string`}</h3>
    <p>{`This example shows how to generate a random string of length 99, with the default character pool.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`$this->mathRandom->getRandomString(99);
`}</code></pre>
    <h3 {...{
      "id": "generate-a-random-number"
    }}>{`Generate a random number`}</h3>
    <p>{`This example shows how to generate a random number between 0 and 9999.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`$this->mathRandom->getRandomNumber(0, 9999);
`}</code></pre>
    <h3 {...{
      "id": "generate-a-random-number-1"
    }}>{`Generate a random number`}</h3>
    <p>{`This example shows how to generate a unique hash string with a prefix.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-php"
      }}>{`$this->mathRandom->getUniqueHash("my_hash_prefix");
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      